import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    pointerAnchor: {
        pointerEvents: "none",
        position: "absolute",
        height: 0,
        width: 0
    },
    anchor: {
        position: "relative"
    },
    childReset: {
        ...webStyle({
            outlineWidth: 0
        })
    }
});
export default stylesheet;
